import { ModalOpenButton, RichTextEditor } from "@msys/ui";
import { Help as HelpIcon } from "@mui/icons-material";
import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ContentState, convertToRaw } from "draft-js";
import { PurchaseOrderTextsAvailableReplacementsModal } from "./PurchaseOrderTextsAvailableReplacementsModal.js";

export const ClosingTextInput = ({
  content,
  onSave = async () => {},
  canEdit,
  showInfo,
}: {
  content?: string | undefined | null;
  onSave?: (variables: any) => Promise<void>;
  canEdit?: boolean;
  showInfo: boolean;
}) => {
  const { t } = useTranslate([
    "PurchaseOrderDetailsForm",
    "Global",
    "OrganisationSettings",
  ]);

  return (
    <Paper>
      <Box padding={2}>
        <RichTextEditor
          label={t("Closing text", {
            ns: "PurchaseOrderDetailsForm",
          })}
          content={
            content
              ? JSON.parse(content)
              : convertToRaw(ContentState.createFromText(""))
          }
          onSave={content => onSave({ closing: JSON.stringify(content) })}
          canEdit={canEdit}
          saveButtonLabel={t("Save", {
            ns: "Global",
          })}
          cancelButtonLabel={t("Cancel", {
            ns: "Global",
          })}
          InfoButton={
            showInfo ? (
              <ModalOpenButton
                Modal={PurchaseOrderTextsAvailableReplacementsModal}
                modalProps={{}}
              >
                <IconButton size="small" color="secondary">
                  <Tooltip
                    title={t("Available replacements", {
                      ns: "OrganisationSettings",
                    })}
                  >
                    <HelpIcon />
                  </Tooltip>
                </IconButton>
              </ModalOpenButton>
            ) : undefined
          }
        />
      </Box>
    </Paper>
  );
};
